import { ValidationsService } from "#src/services/validations.service.js";
import { useIndividualStore } from "#src/stores/individual.js";
import { isNotDefined } from "#src/util/helpers.js";

export class IndividualPrefillService {
  #pinia;
  #validationsService;

  constructor(pinia) {
    this.#pinia = pinia;
    this.#validationsService = new ValidationsService(pinia);
  }

  async savePrefill(partyKey, p = {}) {
    const individual = useIndividualStore(partyKey, this.#pinia);
    const updatedAttributes = [];
    try {
      const prefilledData = this.#normalize(p);
      for (let key in prefilledData) {
        if (isNotDefined(prefilledData[key])) continue;
        individual[key].load(prefilledData[key]);

        if (key === "email") {
          individual[key].externallyValid =
            await this.#validationsService.validateEmail(prefilledData[key]);
        }

        updatedAttributes.push(key);
      }

      const attributesToSave = updatedAttributes.filter(key => {
        const isValid = individual[key].validate();
        if (isValid) return true;
        individual[key].load(null);
        return false;
      });

      if (!attributesToSave.length) return;

      await individual.saveAttributes(attributesToSave);
    } catch (e) {
      updatedAttributes.forEach(attr => individual[attr].load(null));
      throw e;
    }
  }

  #normalize(initPrefill) {
    return {
      street_address: initPrefill.address_street,
      city: initPrefill.address_city,
      state: initPrefill.address_state,
      zip: initPrefill.address_zip,
      country: initPrefill.address_country,
      beneficiary_amount: +initPrefill.beneficiary_amount,
      birthdate: initPrefill.birthdate,
      email: initPrefill.email,
      first_name: initPrefill.first_name,
      last_name: initPrefill.last_name,
      gender: initPrefill.gender,
      phone_mobile: initPrefill.phone_mobile,
      relationship: initPrefill.relationship,
      signature_city: initPrefill.signature_city,
      ssn: initPrefill.ssn,
    };
  }
}
